import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import OptionsAnswerButton from '../OptionsAnswerButton';

import s from './OptionsAnswer.module.scss';

const cx = cn.bind(s);

const OptionsAnswer = ({
  options = [],
  className,
  value,
  multiple,
  max = Infinity,
  onChange,
  color = 'mint',
  ...attrs
}) => {
  const isOptionActive = (v) =>
    v === value || (Array.isArray(value) && value.includes(v));
  const isOptionDisabled = (v) =>
    !isOptionActive(v) && Array.isArray(value) && value.length === max;
  const handleOptionClick = (optionValue) => {
    let newValue;
    if (isOptionDisabled(optionValue)) {
      return;
    }
    if (!multiple) {
      newValue = optionValue;
    } else if (!value || !Array.isArray(value)) {
      newValue = [optionValue];
    } else if (value.includes(optionValue)) {
      newValue = value.filter((v) => v !== optionValue);
    } else if (value.length < max) {
      newValue = [...value, optionValue];
    }
    onChange(newValue);
  };
  const isRow = !multiple && options.length < 3;
  return (
    <div
      className={cx(className, 'wrapper', {
        multiple: multiple || isRow,
        row: isRow,
      })}
      {...attrs}
    >
      {options.map((option) => (
        <OptionsAnswerButton
          key={option.value}
          isActive={isOptionActive(option.value)}
          disabled={isOptionDisabled(option.value)}
          value={option.value}
          label={option.label}
          color={color}
          className={cx('option')}
          onClick={handleOptionClick}
        />
      ))}
    </div>
  );
};
OptionsAnswer.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OptionsAnswer;
